/**
 * Umgebungsvariablen-Konfiguration
 * Stellt Zugriff auf Umgebungsvariablen bereit, auch in Produktionsumgebungen
 */

const env = {
  // n8n Webhook URL für das Kontaktformular
  n8nWebhookUrl: process.env.REACT_APP_N8N_WEBHOOK_URL || 'https://n8n.companion.at/webhook/60bae1b5-227b-4e6b-9495-6aa821dd07ad',
  
  // Weitere Umgebungsvariablen können hier hinzugefügt werden
};

export default env;
